import { createAction } from '@reduxjs/toolkit';
import { audioChatSlice } from './audioChatSlice.ts';

export const AudioChatActions = {
  ...audioChatSlice.actions
};
